import React, { useState } from "react"
import Caption from "./caption"
import Img from "gatsby-image"
import Lightbox from "react-image-lightbox"
// import Fade from 'react-reveal/Fade'
import Spinner from './spinner'

export default ({ fluids, captions, originals, size }) => {
  const [isOpen, setOpen] = useState(false)
  const [photoIndex, setPhotoIndex] = useState(0)
  const images = originals.map(original => original.src)

  return (
    <div>
      <div className="gallery">
        <div className="gallery__thumbnails">
          {fluids.map((fluid, i) => (
            <div
              key={i}
              onClick={() => {
                setPhotoIndex(i)
                setOpen(true)
              }}
            >
              {/* <Fade distance={`1.5rem`} up> */}
              <Img fluid={fluid} backgroundColor="rgba(255, 255, 255, 0.3)" />
              {/* </Fade> */}
            </div>
          ))}
        </div>
        <div className="gallery__captions">
          {captions.map((caption, i) => (
            <Caption key={i} {...caption} />
          ))}
        </div>
      </div>

      {size !== 'large' && isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
          imagePadding={0}
          reactModalProps={{ shouldFocusAfterRender: false }}
          enableZoom={true}
          spinner={Spinner}
        />
      )}
    </div>
  )
}
